import Elixia from '@sats-group/ui-lib/react/logos/elixia';
import ElixiaSpecialSmall from '@sats-group/ui-lib/react/logos/elixia-pride-light';
import ElixiaSmall from '@sats-group/ui-lib/react/logos/elixia-small';
import Sats from '@sats-group/ui-lib/react/logos/sats';
import SatsSpecialSmall from '@sats-group/ui-lib/react/logos/sats-pride-light';
import SatsSmall from '@sats-group/ui-lib/react/logos/sats-small';
import React from 'react';
import type { Logo as Props } from './logo.types';
import { brands, colors, sizes } from './logo.types';

/**
 * When we don't need to render any special version of the small logo anymore, we use this one
 */

const vectors = {
  [brands.elixia]: {
    [sizes.large]: Elixia,
    [sizes.small]: ElixiaSmall,
  },
  [brands.sats]: {
    [sizes.large]: Sats,
    [sizes.small]: SatsSmall,
  },
};

/**
 * We use this one to import any special version of the logo we need,
 * either pride, anniversary or any other version
 */
const specialLogoVectors = {
  [brands.elixia]: {
    [sizes.large]: Elixia,
    [sizes.small]: ElixiaSpecialSmall,
  },
  [brands.sats]: {
    [sizes.large]: Sats,
    [sizes.small]: SatsSpecialSmall,
  },
};

const Logo: React.FC<Props> & {
  brands: typeof brands;
  colors: typeof colors;
  sizes: typeof sizes;
} = ({
  brand = brands.sats,
  color = colors.light,
  href,
  label,
  size = sizes.small,
  specialLogo = false,
}) => {
  const Vector = specialLogo
    ? specialLogoVectors[brand][size]
    : vectors[brand][size];

  return (
    <div className={`logo logo--${color}`}>
      {href ? (
        <a aria-label={label} className="logo__link" href={href}>
          <Vector />
        </a>
      ) : (
        <Vector />
      )}
    </div>
  );
};

Logo.colors = colors;
Logo.brands = brands;
Logo.sizes = sizes;

export default Logo;
